import api from '../api'

const levels = ['browning', 'cooking']

const defaultLabelLevel = (type, defaultLocale) => ({
  type,
  level0: {
    [defaultLocale]: 'Light',
  },
  level1: {
    [defaultLocale]: 'Lighter',
  },
  level2: {
    [defaultLocale]: 'Medium',
  },
  level3: {
    [defaultLocale]: 'Darker',
  },
  level4: {
    [defaultLocale]: 'Dark',
  },
  new: true,
})

const initialState = levels.reduce((acc, level) => ({ ...acc, [level]: null }), {})

export default (state = initialState, action) => {
  switch (action.type) {
    case api.getDefaultLabelLevels.success:
      return {
        ...state,
        [action.route]: action.payload,
      }
    case api.getDefaultLabelLevels.failure:
      return {
        ...state,
        [action.route]: defaultLabelLevel(action.route, action.options.defaultLocale),
      }
    case api.addDefaultLabelLevels.success:
    case api.updateDefaultLabelLevels.success:
      return {
        ...state,
        [action.payload.type]: action.payload,
      }
    default:
      return state
  }
}
